<form-field
  *ngIf="type == 'text' || type == 'number'"
  class="tw-w-full"
  [label]="label"
  [type]="type == 'number' ? 'tel' : 'text'"
  [hasCurrency]="hasCurrency"
  [hasNumberSeparator]="type == 'number' && hasSeparator ? true : false"
  [isOnlyNumber]="type == 'number' ? true : false"
  [(value)]="value"
  (input)="onChangeValue()"
  [formControl]="control"
>
  <!-- clear btn -->
  <div suffix-content class="tw-flex-center">
    <i
      (click)="onClearValue()"
      *ngIf="value"
      class="tw-cursor-pointer mdi mdi-24px mdi-delete-forever text-gray-color tw-relative"
      [matTooltip]="'common.delete' | translate"
    ></i>

    <!-- menu button -->
    <i
      class="mdi mdi-24px tw-ml-1 menu-btn text-navyBlue tw-cursor-pointer tw-relative tw-mx-2"
      [matMenuTriggerFor]="menu"
      [class]="operatorIcons[operator]"
    ></i>
  </div>
</form-field>

<!-- #region menu -->
<mat-menu #menu="matMenu" class="tw-py-1">
  <!--#region text icons -->
  <ng-container *ngIf="type == 'text'">
    <div
      *ngFor="let comparisonOperator of textOperators"
      class="menu-item text-icons tw-border-gray-300 tw-cursor-pointer tw-pr-2"
      (click)="onChangeOperator(comparisonOperator)"
    >
      <!-- icon -->
      <span [class]="operator == comparisonOperator ? 'active' : ''">
        <i
          [class]="
            'mdi mdi-18px tw-text-gray-600 dark:tw-text-gray-300 ' +
            operatorIcons[comparisonOperator]
          "
        ></i>
      </span>

      <!-- title -->
      <span class="tw-mr-1 tw-text-gray-600 dark:tw-text-gray-300"
        >{{ ComparisonOperatorEnumDisplay[comparisonOperator] | translate }}
      </span>
    </div>
  </ng-container>
  <!--#endregion -->

  <!--#region number icons -->
  <ng-container *ngIf="type == 'number'">
    <div
      *ngFor="let comparisonOperator of numberOperators"
      class="menu-item tw-border-gray-300 tw-cursor-pointer tw-pr-2"
      (click)="onChangeOperator(comparisonOperator)"
    >
      <!-- icon -->
      <span [class]="operator == comparisonOperator ? 'active' : ''">
        <i
          [class]="
            'mdi mdi-18px tw-text-gray-600 dark:tw-text-gray-300 ' +
            operatorIcons[comparisonOperator]
          "
        ></i>
      </span>

      <!-- title -->
      <span class="tw-mr-1 tw-text-gray-600 dark:tw-text-gray-300"
        >{{ ComparisonOperatorEnumDisplay[comparisonOperator] | translate }}
      </span>
    </div>
  </ng-container>
  <!--#endregion -->
</mat-menu>
<!-- #endregion -->

<!--#endregion -->

<!-- #region enum -->
<ng-container *ngIf="type == 'enum'">
  <enum-chip-list-select-search
    [enumName]="enumName"
    [control]="control"
    [label]="label"
    [values]="selectedEnumValues"
    (valuesChange)="addOrRemoveEnumValue($event)"
  >
  </enum-chip-list-select-search>
</ng-container>
<!-- #endregion enum -->

<!-- #region boolean -->
<ng-container *ngIf="type == 'boolean'">
  <custom-select-search
    [label]="label"
    [items]="
      $any([
        { value: 'none', name: 'common.all' | translate },
        { value: true, name: 'common.yes' | translate },
        { value: false, name: 'common.no' | translate }
      ])
    "
    [control]="control"
    optionTitle="name"
    optionValue="value"
    [removable]="false"
    [(value)]="value"
    (valueChange)="onChangeValue()"
  >
  </custom-select-search>
</ng-container>

<!-- #endregion -->
